import { setGlobalContext } from 'src/services/datadog';
import { setDatadogAction } from 'src/services/datadog';
import { v4 as uuidv4 } from 'uuid'

const getOrCreatebrowserKey = (() => {

    async function requestPersistentStorage() {
        try {
            if (navigator.storage && navigator.storage.persist) {
                return await navigator.storage.persist();
            }
        } catch (error) {}
        return false;
    }

    function getDB() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open("browserDB", 1);

            request.onupgradeneeded = (event) => {
                let db = event.target.result;
                if (!db.objectStoreNames.contains("keys")) {
                    db.createObjectStore("keys", { keyPath: "id" });
                }
            };

            request.onsuccess = (event) => resolve(event.target.result);
            request.onerror = (event) => reject(event.target.error);
        });
    }

    async function getOrCreatebrowserKey(keyToSet = null) {
        const storageKey = "browser";

        try {
            const db = await getDB();
            
            if (keyToSet && typeof keyToSet === 'string') {
                
                await requestPersistentStorage();

                const writeTransaction = db.transaction("keys", "readwrite");
                const store = writeTransaction.objectStore("keys");

                return new Promise((resolve, reject) => {
                    const request = store.put({ id: storageKey, value: keyToSet }); 

                    request.onsuccess = () => {
                        resolve(keyToSet); 
                    };
                    request.onerror = (event) => {
                        reject(event.target.error);
                    };
                });
            }
            
            const transaction = db.transaction("keys", "readonly");
            const store = transaction.objectStore("keys");

            return new Promise((resolve, reject) => {
                const request = store.get(storageKey);

                request.onsuccess = async () => {
                    let storedKey = request.result ? request.result.value : null;

                    if (storedKey) {
                        setDatadogAction('device_key_retrieved', { storedKey });
                        setGlobalContext({ device_key: storedKey });
                        resolve(storedKey);
                        return;
                    }
                    let keyToSave = uuidv4();

                    await requestPersistentStorage();
                    const writeTransaction = db.transaction("keys", "readwrite");
                    const writeStore = writeTransaction.objectStore("keys");
                    
                    const writeRequest = writeStore.put({ id: storageKey, value: keyToSave });

                    writeRequest.onsuccess = () => {
                        setDatadogAction('device_key_created', { keyToSave });
                        setGlobalContext({ device_key: keyToSave });
                        resolve(keyToSave);
                    };
                    writeRequest.onerror = (event) => {
                        setDatadogAction('device_key_creation_failed', { error: event.target.error });
                        reject(event.target.error);
                    };
                };

                request.onerror = (event) => {
                    setDatadogAction('device_key_retrieval_failed', { error: event.target.error });
                    reject("Error accessing IndexedDB:", event.target.error);
                };
            });
        } catch (error) {
            setDatadogAction('device_key_retrieval_failed', { error: error });
            return "Error handling IndexedDB";
        }
    }

    return getOrCreatebrowserKey;
})();

export { getOrCreatebrowserKey };

